import { render, staticRenderFns } from "./ValidationResponse.vue?vue&type=template&id=471b6b24&"
import script from "./ValidationResponse.vue?vue&type=script&lang=js&"
export * from "./ValidationResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports